<template>
  <router-link
    v-if="iconOnly"
    :to="link"
    :title="text"
    :class="[
      'flex items-center justify-center rounded-lg p-2 h-9 w-9 mx-auto transition-colors outline-none focus-visible:ring-2 focus-visible:ring-ring/50',
      isActive
        ? 'bg-muted text-foreground'
        : 'text-foreground/80 hover:bg-muted hover:text-foreground',
    ]"
  >
    <component :is="iconComponent" v-if="iconComponent" class="h-4 w-4 shrink-0" />
  </router-link>
  <router-link
    v-else
    :to="link"
    :class="[
      'flex items-center gap-2 rounded-lg p-2 text-sm font-medium transition-colors outline-none focus-visible:ring-2 focus-visible:ring-ring/50',
      isActive
        ? 'bg-muted text-foreground'
        : 'text-foreground/90 hover:bg-muted hover:text-foreground',
    ]"
  >
    <component :is="iconComponent" v-if="iconComponent" class="h-4 w-4 shrink-0" />
    <span>{{ text }}</span>
  </router-link>
</template>

<script>
import * as LucideIcons from 'lucide-vue-next'

export default {
  name: 'NavLink',
  props: {
    text: { type: String, required: true },
    icon: { type: String, default: null },
    link: { type: String, required: true },
    iconOnly: { type: Boolean, default: false },
    /**
     * Every route in the same sidebar group, so a link can tell whether a more specific sibling
     * also matches the current path.
     *
     * Without this, `/gift-cards` matches `/gift-cards/orders` by prefix and both links light up.
     */
    siblingRoutes: { type: Array, default: () => [] },
  },
  computed: {
    iconComponent() {
      if (!this.icon) return null
      return LucideIcons[this.icon] || null
    },
    isActive() {
      const path = this.$route.path
      if (this.link === '/') return path === '/'

      const isExact = path === this.link
      const isUnderLink = path.startsWith(this.link + '/')
      if (!isExact && !isUnderLink) return false

      // A longer sibling route that also matches wins, so only the deepest match is active.
      const moreSpecific = this.siblingRoutes.some(
        (route) =>
          route &&
          route !== this.link &&
          route.length > this.link.length &&
          (path === route || path.startsWith(route + '/'))
      )

      return !moreSpecific
    },
  },
}
</script>
